import { makeGistBackend } from './gist';
import type { BackendConfig, BackendKind, RemoteBackend } from './types';

export interface BackendDescriptor {
  kind: BackendKind;
  /** Display label for the cloud-sync section heading. */
  label: string;
}

export const BACKEND_DESCRIPTORS: Record<BackendKind, BackendDescriptor> = {
  gist: { kind: 'gist', label: 'GitHub Gist' },
};

export function createBackend(config: BackendConfig): RemoteBackend {
  switch (config.kind) {
    case 'gist':
      return makeGistBackend(config);
  }
}

/** Strip per-instance state, leaving just the auth/identity bits. */
export function backendCredentials(config: BackendConfig): BackendConfig {
  switch (config.kind) {
    case 'gist':
      return { kind: 'gist', pat: config.pat, remoteId: config.remoteId };
  }
}

export * from './types';
